import React, { useEffect, useRef, useState } from 'react';
import SkeletonBuilder from '../Skeleton/skeleton-builder-component';
import SkeletonImage from '../Skeleton/skeleton-image-component';
import useClickOutside from '../../Hooks/useClickOutside';
import * as authActions from '../../Redux/Auth/AuthActions'
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';

const CourseCard = ({ course, selected, close }) => {
    const [courseData, setCourseData] = useState(undefined);
    const [isOpen, setIsOpen] = useState(selected);
    const courseModalRef = useRef(null);
    const recipeJson = course?.recipe_json || undefined;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleRedirect = async (e) => {
        e.preventDefault();
        const redirectPath = '/contact';
        dispatch(authActions.redirectScreen(redirectPath))
        navigate(redirectPath);
    }


    useClickOutside(courseModalRef, (e) => close(e));

    useEffect(() => {
        if (isOpen) {
            // Disable scrolling
            document.body.style.overflow = 'hidden';
        } else {
            // Enable scrolling
            document.body.style.overflow = '';
        }

        // Clean up
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    useEffect(() => {
        try {
            setIsOpen(selected);
            if (typeof recipeJson === 'object') {
                setCourseData(recipeJson);
            } else if (recipeJson !== undefined) {
                setCourseData(JSON.parse(recipeJson));
            }
        } catch (error) {
            console.log(error);
            setCourseData(undefined);
        }
    }, [recipeJson, selected]);

    const closeModal = async (e) => {
        e.preventDefault();
        close(e);
    }

    return (
        <div className="">
            {window.innerWidth < 768 ? (
                <div className={`${course && isOpen ? 'opacity-100 pointer-events-auto z-30' : 'opacity-0 pointer-events-none'} duration-500 fixed left-0 top-0 bg-white dark:bg-black w-screen h-screen transition-all ease-in-out`}>
                    <div>
                        <div className={`flex flex-col w-screen h-screen justify-start bg-white border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700`}>

                            <div className="flex w-full align-top justify-start">
                                {(course?.image && !course.video) ?
                                    (
                                        <img src={course?.image} alt="" className="flex align-top justify-start  aspect-[1] h-auto max-w-full" />
                                    ) : (
                                        <video key={course?.video} autoPlay loop muted playsInline>
                                            <source src={course?.video} type="video/mp4" className="flex align-top justify-start  aspect-[1] h-auto max-w-full" />
                                        </video>)
                                }
                            </div>
                            {/* <div className="flex w-full align-top justify-start">
                            <video key={course?.image} autoPlay loop muted playsInline>
                                <source src={course?.image} type="video/mp4" className="flex align-top justify-start  aspect-[1] h-auto max-w-full" />
                            </video>
                        </div> */}

                        </div>
                        <div ref={courseModalRef} className={`${isOpen ? 'p-6 h-3/5' : 'p-6 h-1/5'} absolute z-50 bottom-0 self-center bg-white dark:bg-gray-900 w-full rounded-3xl transition-all ease-in-out delay-300 duration-300 overflow-y-scroll text-left `}>
                            <div className="text-3xl text-black dark:text-white font-bold text-center pb-8">
                                {course?.title}
                            </div>
                            <div className={`${course ? 'opacity-100 pointer-events-auto z-30' : 'opacity-0 pointer-events-none hidden'}`}>
                                <div className="mb-4">
                                    <h3 className="text-xl font-bold mb-1">{course?.subtitle}</h3>
                                </div>
                                <div className="mb-4">
                                    <h3 className="text-lg font-bold mb-1">What will you learn?:</h3>
                                    <ul className="list-decimal ml-4 text-left">
                                        {course?.additionalTopics?.split(',').map((topic, step) => (
                                            <div key={step} className=' text-left m-2' >{`-${topic}`}</div>
                                        ))}
                                    </ul>
                                </div>
                                <div className="mb-4">
                                    <h3 className="text-lg font-bold mb-1">Duration</h3>
                                    <p className="text-gray-700 dark:text-white">{course?.duration}</p>
                                </div>
                                <div className="mb-4">
                                    <h3 className="text-lg font-bold mb-1">Participates</h3>
                                    <p className="text-gray-700 dark:text-white text-left">{course?.suggestedParticipants}</p>
                                </div>
                                {/* <div className="mb-4">
                                    <h3 className="text-lg font-bold mb-1">:מחיר</h3>
                                    <p className="text-gray-700 dark:text-white">{course?.price}₪</p>
                                </div> */}
                            </div>
                            <div className={`${!course?.subtitle ? 'opacity-100 pointer-events-auto z-30' : 'opacity-0 pointer-events-none hidden'}`}>
                                <div className="relative mt-10">
                                    <SkeletonBuilder type={"LargeText"} count={3} />
                                </div>
                                <div className="relative mt-5">
                                    <SkeletonBuilder type={"LargeText"} count={2} />
                                </div>
                                <div className="relative mt-5">
                                    <SkeletonBuilder type={"AreaChart"} count={1} />
                                </div>
                            </div>
                            <div className="relative left-0 bottom-0 w-full self-center px-6 flex-col mb-2">
                                <button
                                    onClick={handleRedirect}
                                    className="flex button-component px-5 ">
                                        Contact
                                </button>
                                <button
                                    onClick={(e) => { close(e); }}
                                    className="button-component-transparent px-5 mt-2 mb-4">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={`${isOpen ? 'opacity-100 pointer-events-auto z-30' : 'opacity-0 pointer-events-none'} duration-500 fixed left-0 top-0 bg-opacity-90 bg-black w-screen h-screen transition-all ease-in-out align-middle `}>
                    <div ref={courseModalRef} className="fixed justify-center align-middle bg-white dark:bg-gray-800 flex-col top-1/4  w-full py-5 rounded-xl">
                        <div className="flex justify-end w-full" >
                            <button onClick={closeModal}>
                                <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </button>
                        </div>

                        <div className='flex flex-row justify-center align-middle text-center ml-20 h-1/2 w-full self-center' >
                            <div className='flex w-2/5 items-center align-middle hover:scale-105  transition-all ease-in-out duration-300 '>
                                {(course?.image && !course.video) ?
                                    (
                                        <img src={course?.image} alt="" className="flex align-top justify-start p-2 rounded-2xl aspect-[1] h-auto max-w-full" />
                                    ) : (
                                        <video key={course?.video} autoPlay loop muted playsInline className='flex p-3 rounded-3xl '>
                                            <source src={course?.video} type="video/mp4" className="flex align-top justify-start aspect-[1] h-auto max-w-full" />
                                        </video>)
                                }

                                {!course?.image && !course?.video &&
                                    <SkeletonImage />
                                }

                            </div>

                            <div className="flex flex-col justify-center w-full my-1 rounded-xl mr-5 mx-10">
                                <h5 className="mb-2 text-4xl font-bold text-gray-700 dark:text-gray-400">{course?.title}</h5>

                                <div className="flex flex-row justify-center text-gray-600 dark:text-gray-200">
                                    <p className="flex text-xs my-2 mx-1 text-start font-normal  lg:text-lg ">₪</p>
                                    <p className="flex text-6xl text-center font-semibold lg:text-6xl">{course?.price}</p>
                                    <p className="flex text-2xl font-normal items-end lg:text-2xl ">.00</p>
                                </div>
                                <div className='pt-15 pb-4 flex w-full justify-center align-middle items-center'>
                                    <div className='flex w-1/2 flex-col '>
                                        <button
                                            onClick={handleRedirect}
                                            className="flex button-component px-5 mt-5">
                                            עוד מידע
                                        </button>
                                        <button
                                            onClick={closeModal}
                                            className="flex button-component px-5 my-2">
                                            סגור
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>



                    </div>

                </div>
            )}

        </div>
    );
};

export default CourseCard;
